import { Controller } from "@hotwired/stimulus"
import { lock, unlock } from "../helpers/body_scroll_lock"

// Global search modal — pulls /search results into a turbo-frame as
// the user types. No navigation.
export default class extends Controller {
  static targets = ["overlay", "input", "frame"]
  static values = { url: String }

  connect() {
    this._onViewportResize = this.adjustForKeyboard.bind(this)
    window.visualViewport?.addEventListener("resize", this._onViewportResize)
    window.visualViewport?.addEventListener("scroll", this._onViewportResize)
  }

  disconnect() {
    window.visualViewport?.removeEventListener("resize", this._onViewportResize)
    window.visualViewport?.removeEventListener("scroll", this._onViewportResize)
  }

  open() {
    this.overlayTarget.classList.remove("hidden")
    this.element.dataset.open = "true"
    lock()
    requestAnimationFrame(() => this.inputTarget?.focus())
  }

  close() {
    this.overlayTarget.classList.add("hidden")
    this.overlayTarget.style.bottom = ""
    this.element.dataset.open = "false"
    unlock()
  }

  backdropClose(event) {
    if (event.target === event.currentTarget) this.close()
  }

  // Lift the overlay above the iOS keyboard when it appears, so search
  // results stay visible. Falls back to the CSS bottom value when hidden.
  adjustForKeyboard() {
    if (this.element.dataset.open !== "true" || !window.visualViewport) return
    const vv = window.visualViewport
    const keyboardOffset = window.innerHeight - vv.height - vv.offsetTop
    if (keyboardOffset > 50) {
      this.overlayTarget.style.bottom = `${keyboardOffset}px`
    } else {
      this.overlayTarget.style.bottom = ""
    }
  }

  search() {
    clearTimeout(this._timer)
    const q = this.inputTarget.value.trim()
    this._timer = setTimeout(() => {
      const url = new URL(this.urlValue, window.location.origin)
      url.searchParams.set("q", q)
      this.frameTarget.src = url.toString()
    }, 250)
  }
}
